const initialState = {
  tools: { data: [] },
  allEquipmentMapping: [],
};

export const tools_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_TOOLS":
      return {
        ...state,
        tools: action.payload,
      };
    case "GET_ALL_EQUIPMENTS_MAPPING":
      return {
        ...state,
        allEquipmentMapping: action.payload,
      };
    case "DELETE_TOOL":
      return {
        ...state,
        tools: {
          ...state.tools,
          data: state.tools.data.filter((li) => li.id !== action.payload),
        },
      };
    default:
      return state;
  }
};
